import { CaretDownFilled, CaretUpFilled } from "@ant-design/icons";
import { Popover } from "antd";
import { COLOR_CODES } from "../../../util/helper/constants";

export const SortableHeader = ({
  enableSort = false,
  label, 
  field,
  sortConfig,
  requestSort
}) => {
  const isActive = sortConfig?.key === field;
  const direction = sortConfig?.direction;

  const activeColor = COLOR_CODES.azureBlue;
  const inactiveColor = COLOR_CODES.silver;

  return (
    <th className="block-table-header-block-rack">
      <span style={{ display: "inline-flex", alignItems: "center", gap: 4 }}>
        {label}
        {enableSort && (
          <span
            style={{ display: "flex", flexDirection: "column", lineHeight: 1 }}
          >
            <Popover content={`Sort by asc`}>
              <CaretUpFilled
                style={{
                  fontSize: 12,
                  color:
                    isActive && direction === "asc"
                      ? activeColor
                      : inactiveColor
                }}
                onClick={() => requestSort(field, "asc")}
              />
            </Popover>

            <Popover content={`Sort by desc`}>
              <CaretDownFilled
                style={{
                  fontSize: 12,
                  color:
                    isActive && direction === "desc"
                      ? activeColor
                      : inactiveColor
                }}
                onClick={() => requestSort(field, "desc")}
              />
            </Popover>
          </span>
        )}
      </span>
    </th>
  );
};
